module.exports = __webpack_public_path__ + "img/instagram-icon.c477b1cc.svg";